import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/psf/share/pageContext';

export const PsfShareErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for PsfShare page (error: ${error})`);
};
